(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sbg-product-back"] && !Shopify.designMode) return;
  try {
    function sbgProductBackInit() {
  document.querySelectorAll('[data-sbg-product-back]').forEach(function(link) {
    if (link.dataset.ready) return;
    link.dataset.ready = 'true';
    try {
      const previous = new URL(document.referrer);
      const current = new URL(location.href);
      if (previous.origin !== current.origin || previous.href === current.href ||
          !/\/(collections|search|pages)(\/|$)/.test(previous.pathname) ||
          /\/collections\/all\/?$/.test(previous.pathname)) return;
      link.href = previous.href;
      link.addEventListener('click', function(event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        location.assign(link.href);
      });
    } catch (error) {}
  });
}
sbgProductBackInit();
document.addEventListener('shopify:section:load', sbgProductBackInit);
  } catch(e) { console.error(e); }
})();

})();
